{
	"name": "@cloudillo/mapillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Mapillo OpenStreetMap map app",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"ts": "tsgo --noEmit",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilard Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/core": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@symbion/opalui": "^0.16.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"esbuild": "^0.28.2",
		"maplibre-gl": "^6.15.0",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-icons": "^5.7.0",
		"rimraf": "^6.1.3",
		"tslib": "^2.8.1",
		"typescript": "^7.0.2"
	}
}
